(() => {
  'use strict';
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');

  function bindOnce(el, key) {
    if (!el || el.dataset['gardBound' + key]) return false;
    el.dataset['gardBound' + key] = '1';
    return true;
  }

  function init(root) {
    if (!bindOnce(root, 'Product')) return;
    const $ = (s, r = root) => r.querySelector(s);
    const $$ = (s, r = root) => [...r.querySelectorAll(s)];
    const name = ($('.product-summary h1')?.textContent || '').trim();

    const thumbs = $$('[data-gallery]');
    const mainImage = $('#productImage');
    let active = Math.max(0, thumbs.findIndex(b => b.getAttribute('aria-pressed') === 'true'));
    const show = i => {
      if (!thumbs.length || !mainImage) return;
      active = (i + thumbs.length) % thumbs.length;
      mainImage.src = thumbs[active].dataset.src;
      mainImage.alt = 'Gard ' + name + ', ' + (active + 1) + '. görsel';
      thumbs.forEach((b, j) => b.setAttribute('aria-pressed', String(j === active)));
    };
    thumbs.forEach((b, i) => b.addEventListener('click', () => show(i)));
    $('.product-gallery')?.addEventListener('keydown', e => {
      if (!thumbs.length || (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft')) return;
      e.preventDefault(); show(active + (e.key === 'ArrowRight' ? 1 : -1)); thumbs[active].focus();
    });

    const quantity = $('#quantity');
    const variantSelect = $('[data-variant-select]');
    const variantInput = $('input[name="id"]', $('.gard-product-form') || root);
    const buyNow = $('[data-buy-now]');
    const currentVariant = () => variantSelect ? variantSelect.selectedOptions[0] : null;
    const clampQty = () => {
      if (!quantity) return 1;
      const n = Math.max(1, Math.min(99, Math.trunc(Number(quantity.value) || 1)));
      quantity.value = String(n);
      return n;
    };
    const pack = $('[data-pack]');
    const packRadios = pack ? $$('input[type="radio"]', pack) : [];
    const syncPack = () => {
      if (!packRadios.length) return;
      const n = clampQty();
      packRadios.forEach(r => { r.checked = Number(r.value) === n; r.closest('.pdp-pack-option')?.classList.toggle('is-selected', r.checked); });
    };
    const packPrices = () => {
      const option = currentVariant();
      if (!pack || !option) return;
      const cents = Number(option.dataset.priceCents), off = Number(pack.dataset.packOff) || 0;
      if (!Number.isFinite(cents)) return;
      const money = v => (window.GardFormat ? window.GardFormat.money(v / 100) : (v / 100).toFixed(2));
      $$('[data-pack-price]', pack).forEach(el => {
        const n = Number(el.dataset.packPrice), full = cents * n, final = n > 1 ? Math.floor(full * (100 - off) / 100) : full;
        const f = $('[data-pack-final]', el), d = $('[data-pack-full]', el);
        if (f) f.textContent = money(final);
        if (d) d.textContent = money(full);
      });
      pack.disabled = option.dataset.available !== 'true';
    };
    const syncBuyNow = () => {
      if (!buyNow) return;
      const option = currentVariant();
      const id = option ? option.value : variantInput?.value;
      const available = option ? option.dataset.available === 'true' : !buyNow.hasAttribute('aria-disabled');
      const base = buyNow.dataset.cartBase || '/cart';
      buyNow.textContent = available ? 'Hemen satın al' : 'Tükendi';
      if (available && id) { buyNow.href = base + '/' + id + ':' + clampQty(); buyNow.removeAttribute('aria-disabled'); buyNow.removeAttribute('tabindex'); }
      else { buyNow.removeAttribute('href'); buyNow.setAttribute('aria-disabled', 'true'); buyNow.tabIndex = -1; }
    };
    $('#quantityMinus')?.addEventListener('click', () => { if (quantity) { quantity.value = String(Number(quantity.value) - 1); clampQty(); syncBuyNow(); syncPack(); } });
    $('#quantityPlus')?.addEventListener('click', () => { if (quantity) { quantity.value = String(Number(quantity.value) + 1); clampQty(); syncBuyNow(); syncPack(); } });
    quantity?.addEventListener('change', () => { clampQty(); syncBuyNow(); syncPack(); });
    packRadios.forEach(r => r.addEventListener('change', () => { if (!r.checked || !quantity) return; quantity.value = r.value; clampQty(); syncBuyNow(); syncPack(); }));
    buyNow?.addEventListener('click', e => { syncBuyNow(); if (buyNow.getAttribute('aria-disabled') === 'true') e.preventDefault(); });
    variantSelect?.addEventListener('change', () => {
      const media = currentVariant()?.dataset.media;
      if (media) { const i = thumbs.findIndex(b => b.dataset.gardMedia === media); if (i > -1) show(i); }
      syncBuyNow();
      packPrices();
    });
    syncBuyNow();
    syncPack();

    $$('[data-compare]').forEach(input => input.addEventListener('input', () => {
      input.closest('.pdp-comparison')?.style.setProperty('--split', input.value + '%');
    }));

    const videos = $$('.pdp-videos video');
    videos.forEach(v => v.addEventListener('play', () => videos.forEach(o => { if (o !== v) o.pause(); })));
    const rail = $('.pdp-video-rail');
    const prev = $('[data-videos-prev]'), next = $('[data-videos-next]'), bar = $('.pdp-videos-progress');
    if (rail && rail.classList.contains('is-empty')) { if (prev) prev.disabled = true; if (next) next.disabled = true; }
    else if (rail) {
      const step = () => (rail.firstElementChild?.getBoundingClientRect().width || 240) + 16;
      const sync = () => {
        const max = rail.scrollWidth - rail.clientWidth;
        const ratio = max > 0 ? rail.clientWidth / rail.scrollWidth : 1;
        const offset = max > 0 ? rail.scrollLeft / max : 0;
        const thumb = bar?.firstElementChild;
        if (thumb) { thumb.style.width = (ratio * 100) + '%'; thumb.style.transform = `translateX(${offset * (1 - ratio) / ratio * 100}%)`; }
        if (prev) prev.disabled = rail.scrollLeft <= 2;
        if (next) next.disabled = rail.scrollLeft >= max - 2;
      };
      prev?.addEventListener('click', () => rail.scrollBy({ left: -step(), behavior: reduced.matches ? 'auto' : 'smooth' }));
      next?.addEventListener('click', () => rail.scrollBy({ left: step(), behavior: reduced.matches ? 'auto' : 'smooth' }));
      rail.addEventListener('scroll', sync, { passive: true });
      addEventListener('resize', sync);
      sync();
      if ('IntersectionObserver' in window) {
        const io = new IntersectionObserver(entries => entries.forEach(en => { if (!en.isIntersecting) en.target.pause(); }), { root: rail, threshold: .4 });
        videos.forEach(v => io.observe(v));
      }
    }

    const sticky = $('.pdp-sticky-buy'), summary = $('.product-summary');
    if (sticky && summary && 'IntersectionObserver' in window) {
      new IntersectionObserver(([entry]) => {
        sticky.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.bottom < 0);
      }, { threshold: 0 }).observe(summary);
    }

    if (mainImage) {
      mainImage.tabIndex = 0;
      mainImage.setAttribute('role', 'button');
      mainImage.setAttribute('aria-label', 'Ürün fotoğrafını büyüt');
      mainImage.style.cursor = 'zoom-in';
      const zoom = document.createElement('dialog');
      zoom.className = 'product-zoom';
      zoom.setAttribute('aria-label', 'Büyük ürün fotoğrafı');
      const close = document.createElement('button');
      close.type = 'button'; close.textContent = '×'; close.setAttribute('aria-label', 'Büyük fotoğrafı kapat');
      const enlarged = document.createElement('img');
      zoom.append(close, enlarged);
      document.body.append(zoom);
      const open = () => { enlarged.src = mainImage.src.replace(/width=\d+/, 'width=2000'); enlarged.alt = mainImage.alt; zoom.showModal(); };
      mainImage.addEventListener('click', open);
      mainImage.addEventListener('keydown', e => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); open(); } });
      close.addEventListener('click', () => zoom.close());
      zoom.addEventListener('click', e => { if (e.target === zoom) zoom.close(); });
      zoom.addEventListener('close', () => mainImage.focus());
    }
  }

  const start = (scope = document) => scope.querySelectorAll('[data-product-page]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => start(), { once: true }); else start();
  document.addEventListener('shopify:section:load', e => start(e.target));
})();
